
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class EsyLabel extends Vue {
  @Prop({ default: "black" }) color: string;
  @Prop({ default: "hsl( 180, 5%, 92%)" }) backgroundColor: string;
}
